export default "__VITE_ASSET__1T_nrqpM__"